import React from 'react';
import Version from './Version';
import NoteDisplay from './NoteDisplay';
export default function Activity({ activity, isBuilding }) {
    // If it's a note, it will have a 'type' property
    if ('notes' in activity) {
        return React.createElement(NoteDisplay, { note: activity, isBuilding: isBuilding });
    }
    // Otherwise, treat as Version
    return React.createElement(Version, { version: activity });
}
